<template>
  <div class="image-upload">
    <div class="controls">
      <el-button
        icon="el-icon-refresh"
        size="small" v-on:click.stop="reset">
        <!-- 重置 -->
        重置
      </el-button>
      <el-button
        icon="el-icon-upload"
        size="small" v-on:click.stop="upload">
        <!-- 上传 -->
        上传
      </el-button>
    </div>
    <el-upload
      ref="upload"
      drag
      action="#"
      :accept="type"
      :auto-upload="false"
      :file-list="list"
      :list-type="'picture-card'"
      multiple>
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}" class="img-thumb">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url" alt=""
        >
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-image-viewer :z-index="9999" v-if="preview.show" :on-close="preview.close" :url-list="[preview.url]"></el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'Upload',
  components: {
    ElImageViewer
  },
  props: {
    type: {
      type: String,
      default: 'image/*', // video/* audio/* image/* .pdf .xls .doc
    },
    
  },
  data() {
    return {
      list: [],
      disabled: false,
      preview: {
        show: false,
        url: '',
        close: () => {
          this.preview.show = false,
          this.preview.url = ''
        }
      }
    }
  },
  methods: {
    async upload() {
      // 按顺序上传图片
      const files = this.$refs.upload.uploadFiles;
      const result = []
      if (files.length === 0) {
        // this.$message.error('请选择图片')
        this.$message.error(`请选择图片`)
        return
      }
      for (const file of files) {
        const item = {
          raw: file.raw,
          filename: file.name,
          size: file.size
        }

        const res = await this.$upload.start(item)
        result.push(res)
      }
      
      this.complete(result)
    },
    complete(list) {
      this.$emit('complete', list)
      this.reset()
    },
    handleRemove(file) {
      const list = this.$refs.upload.uploadFiles
      list.forEach((i, d) => {
        if (file.uid === i.uid) {
          list.splice(d, 1)
        }
      })
    },
    handlePictureCardPreview(file) {
      this.$set(this.preview, 'url', file.url)
      this.$set(this.preview, 'show', true)
    },
    reset() {
      this.list = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .image-upload {
    .controls {
      margin-bottom: 10px;
    }
    /deep/ .el-dialog {
      width: 820px;
    }
    /deep/ .el-dialog__body {
      padding-top: 0 !important;
    }
  }
  .img-viewer {
    /deep/ .el-dialog {
      margin-top: 4vh !important;
    }
  }
  .img-thumb {
    height: 100%;
  }
  /deep/ .el-upload-dragger {
    width: 148px;
    height: 148px;
  }
  /deep/ .el-upload--picture-card {
    border: none;
  }
  /deep/ .el-upload-list--picture-card {
    .el-upload-list__item {
      border: none;
    }
  }
</style>